import { __extends } from "tslib";
import { Point as APoint } from '@awayjs/core';
import { StageManager } from '@awayjs/stage';
import { SceneImage2D } from '@awayjs/scene';
import { notImplemented } from '@awayfl/swf-loader';
import { ASObject } from '@awayfl/avm2';
var ALER_TABLE = {};
var ALERT_ONCE = function (id, message) {
    if (ALER_TABLE[id])
        return;
    console.warn(id + ":", message);
    ALER_TABLE[id] = true;
};
var BitmapData = /** @class */ (function (_super) {
    __extends(BitmapData, _super);
    function BitmapData(width, height, transparent, fillColor) {
        if (transparent === void 0) { transparent = true; }
        if (fillColor === void 0) { fillColor = 0xffffffff; }
        var _this = _super.call(this) || this;
        _this._owners = new Array();
        if (typeof width === 'number') {
            if (!_this._adaptee) {
                _this._adaptee = SceneImage2D.getImage(width, height, transparent, fillColor, false, StageManager.getInstance().getStageAt(0));
                // we construct a SceneImage2D direct, use weak, that call dispose after garbaging
                _this._adaptee.useWeakRef();
            }
        }
        else {
            _this._adaptee = width;
        }
        _this._adaptee.adapter = _this;
        return _this;
    }
    // for AVM1:
    BitmapData.prototype.compare = function (other) {
        return true;
    };
    Object.defineProperty(BitmapData.prototype, "adaptee", {
        get: function () {
            return this._adaptee;
        },
        set: function (value) {
            this._adaptee = value;
        },
        enumerable: true,
        configurable: true
    });
    BitmapData.loadBitmap = function (id) {
        console.log('loadBitmap not implemented yet in flash/BitmapData');
        return null;
    };
    BitmapData.prototype.setPixels = function (rect, inputByteArray) {
        console.log('todo: BitmapData.setPixels');
        //this._putPixelData(rect, new Int32Array(inputByteArray.readRawBytes()));
    };
    BitmapData.prototype.getPixels = function (rect) {
        var buffer = this.adaptee.getPixels(rect.adaptee);
        var arr = new this.sec.flash.utils.ByteArray();
        // @ts-ignore
        arr.setArrayBuffer(buffer.buffer);
        //console.log('getPixels not implemented yet in flash/BitmapData');
        return arr;
    };
    BitmapData.prototype.copyPixelsToByteArray = function (rect, data) {
        console.log('copyPixelsToByteArray not implemented yet in flash/BitmapData');
    };
    BitmapData.prototype.getVector = function (rect) {
        var buffer = this.adaptee.getPixels(rect.adaptee);
        // construct small buffer
        var vector = new this.sec.Uint32Vector(0, true);
        // replace a buffer for avoid copeing
        //@ts-ignore
        vector._buffer = new Uint32Array(buffer.buffer);
        // remap size
        //@ts-ignore
        vector._length = buffer.length / 4;
        return vector;
    };
    BitmapData.prototype.setVector = function (rect, inputVector) {
        notImplemented('public flash.display.BitmapData::encode');
    };
    BitmapData.prototype.histogram = function (hRect) {
        if (hRect === void 0) { hRect = null; }
        notImplemented('public flash.display.BitmapData::encode');
        return;
    };
    BitmapData.prototype.encode = function (rect, compressor, byteArray) {
        if (byteArray === void 0) { byteArray = null; }
        notImplemented('public flash.display.BitmapData::encode');
        return;
    };
    BitmapData.prototype.drawWithQuality = function (source, matrix, colorTransform, blendMode, clipRect, smoothing, quality) {
        if (matrix === void 0) { matrix = null; }
        if (colorTransform === void 0) { colorTransform = null; }
        if (blendMode === void 0) { blendMode = null; }
        if (clipRect === void 0) { clipRect = null; }
        if (smoothing === void 0) { smoothing = false; }
        if (quality === void 0) { quality = null; }
        notImplemented('public flash.display.BitmapData::drawWithQuality');
    };
    Object.defineProperty(BitmapData.prototype, "transparent", {
        get: function () {
            return this._adaptee.transparent;
        },
        set: function (value) {
            this._adaptee.transparent = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BitmapData.prototype, "width", {
        get: function () {
            return this._adaptee.width;
        },
        set: function (value) {
            this._adaptee.width = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BitmapData.prototype, "height", {
        get: function () {
            return this._adaptee.height;
        },
        set: function (value) {
            this._adaptee.height = value;
        },
        enumerable: true,
        configurable: true
    });
    BitmapData.prototype.clone = function () {
        var clone = new this.sec.flash.display.BitmapData(this._adaptee.width, this._adaptee.height, this._adaptee.transparent, null);
        // refclone
        if (this._adaptee.copyTo) {
            this._adaptee.copyTo(clone._adaptee);
        }
        else {
            clone.copyPixels(this, this.rect, new this.sec.flash.geom.Point());
        }
        return clone;
    };
    Object.defineProperty(BitmapData.prototype, "rect", {
        get: function () {
            return new this.sec.flash.geom.Rectangle(this._adaptee.rect.clone());
        },
        enumerable: true,
        configurable: true
    });
    BitmapData.prototype.getPixel = function (x, y) {
        return this._adaptee.getPixel(x, y);
    };
    BitmapData.prototype.getPixel32 = function (x, y) {
        return this._adaptee.getPixel32(x, y);
    };
    BitmapData.prototype.setPixel = function (x, y, color) {
        this._adaptee.setPixel(x, y, color);
    };
    BitmapData.prototype.setPixel32 = function (x, y, color) {
        this._adaptee.setPixel32(x, y, color);
    };
    BitmapData.prototype.applyFilter = function (sourceBitmap, sourceRect, destPoint, filter) {
        console.log('applyFilter not implemented yet in flash/BitmapData');
        return 0;
    };
    BitmapData.prototype.colorTransform = function (rect, colorTransform) {
        this._adaptee.colorTransform(rect.adaptee, colorTransform.adaptee);
    };
    BitmapData.prototype.copyChannel = function (sourceBitmap, sourceRect, destPoint, sourceChannel, destChannel) {
        this._adaptee.copyChannel(sourceBitmap.adaptee, sourceRect.adaptee, destPoint.adaptee, sourceChannel, destChannel);
    };
    BitmapData.prototype.copyPixels = function (sourceBitmap, sourceRect, destPoint, alphaBitmapData, alphaPoint, mergeAlpha) {
        if (alphaBitmapData === void 0) { alphaBitmapData = null; }
        if (alphaPoint === void 0) { alphaPoint = null; }
        if (mergeAlpha === void 0) { mergeAlpha = false; }
        this._adaptee.copyPixels(sourceBitmap.adaptee, sourceRect.adaptee, destPoint.adaptee, alphaBitmapData ? alphaBitmapData.adaptee : null, alphaPoint ? alphaPoint.adaptee : null, mergeAlpha);
    };
    BitmapData.prototype.dispose = function () {
        // already disposed or not setted
        if (!this._adaptee) {
            return;
        }
        this._adaptee.dispose();
        this._adaptee = null;
    };
    BitmapData.prototype.draw = function (source, matrix, colorTransform, blendMode, clipRect, smooth) {
        if (colorTransform === void 0) { colorTransform = null; }
        if (blendMode === void 0) { blendMode = ''; }
        if (clipRect === void 0) { clipRect = null; }
        if (smooth === void 0) { smooth = false; }
        this._adaptee.draw(source.adaptee, matrix ? matrix.adaptee : null, colorTransform ? colorTransform.adaptee : null, blendMode, clipRect ? clipRect.adaptee : null, smooth);
    };
    BitmapData.prototype.fillRect = function (rect, color) {
        // var colorArr = ColorUtils.float32ColorToARGB(color);
        // color = ColorUtils.ARGBtoFloat32(colorArr[0], colorArr[3], colorArr[2], colorArr[1]);
        this._adaptee.fillRect(rect.adaptee, color);
    };
    BitmapData.prototype.floodFill = function (x, y, color) {
        ALERT_ONCE('floodFill:' + this._adaptee.id, 'Unsage implementation!');
        this._adaptee.floodFill(x, y, color);
    };
    BitmapData.prototype.generateFilterRect = function (sourceRect, filter) {
        console.log('generateFilterRect not implemented yet in flash/BitmapData');
        return null;
    };
    BitmapData.prototype.getColorBoundsRect = function (mask, color, findColor) {
        ALERT_ONCE('getColorBoundsRect:' + this._adaptee.id, 'Unsage implementation!');
        return new this.sec.flash.geom.Rectangle(this._adaptee.getColorBoundsRect(mask, color, findColor));
    };
    BitmapData.prototype.hitTest = function (firstPoint, firstAlphaThreshold, secondObject, secondBitmapPoint, secondAlphaThreshold) {
        if (secondBitmapPoint === void 0) { secondBitmapPoint = new this.sec.flash.geom.Point(0, 0); }
        if (secondAlphaThreshold === void 0) { secondAlphaThreshold = 0; }
        console.log('hitTest not implemented yet in flash/BitmapData');
        return false;
    };
    BitmapData.prototype.lock = function () {
        this._adaptee.lock();
    };
    BitmapData.prototype.merge = function (sourceBitmap, sourceRect, destPoint, redMult, greenMult, blueMult, alphaMult) {
        this._adaptee.merge(sourceBitmap.adaptee, sourceBitmap.rect.adaptee, destPoint.adaptee, redMult, greenMult, blueMult, alphaMult);
    };
    BitmapData.prototype.noise = function (randomSeed, low, high, channelOptions, grayScale) {
        console.log('noise not implemented yet in flash/BitmapData');
    };
    BitmapData.prototype.paletteMap = function (sourceBitmap, sourceRect, destPoint, redArray, greenArray, blueArray, alphaArray) {
        console.log('paletteMap not implemented yet in flash/BitmapData');
    };
    BitmapData.prototype.perlinNoise = function (baseX, baseY, numOctaves, randomSeed, stitch, fractalNoise, channelOptions, grayScale, offsets) {
        console.log('perlinNoise not implemented yet in flash/BitmapData');
    };
    BitmapData.prototype.pixelDissolve = function (sourceBitmap, sourceRect, destPoint, randomSeed, numberOfPixels, fillColor) {
        console.log('pixelDissolve not implemented yet in flash/BitmapData');
        return 0;
    };
    BitmapData.prototype.scroll = function (x, y) {
        x = x | 0;
        y = y | 0;
        // 0, 0 scroll - is not scroll
        if (!x && !y)
            return;
        this._adaptee.copyPixels(this._adaptee, this._adaptee.rect, new APoint(x, y), null, null, false);
        //console.log('scroll not implemented yet in flash/BitmapData');
    };
    BitmapData.prototype.threshold = function (sourceBitmap, sourceRect, destPoint, operation, threshold, color, mask, copySource) {
        this._adaptee.threshold(sourceBitmap.adaptee, sourceRect.adaptee, destPoint.adaptee, operation, threshold, color, mask, copySource);
        return 0; //number of pixels is not implemented
    };
    BitmapData.prototype.unlock = function () {
        this._adaptee.unlock();
    };
    BitmapData.prototype._addOwner = function (owner) {
        if (this._owners.indexOf(owner) == -1)
            this._owners.push(owner);
    };
    BitmapData.prototype._removeOwner = function (owner) {
        var index = this._owners.indexOf(owner);
        if (index != -1)
            this._owners.splice(index, 1);
        if (!this._owners.length && this._adaptee)
            this._adaptee.clear();
    };
    return BitmapData;
}(ASObject));
export { BitmapData };
